import React, {Component} from 'react';
import {dispatch} from 'react-redux';
import {Grid, Row, Col, Jumbotron, Modal} from 'react-bootstrap';
import {HashLink as Link} from 'react-router-hash-link';
import veri_sign from '../logo-verisign.png';
import inituit_logo from '../intuit-logo.png';
import TrustEBrandLogo from "./truste-brand-logo";


class NotFound extends Component {

    state = {show: true};


    constructor(props) {
        super(props);

    }

    render() {

        return (

            <div>
                <Grid>
                    <Jumbotron className="not-logged-in">
                        <h4><font color="green"><b>No Benefit Plan found</b></font></h4>
                        <br/>
                        <font face="verdana" size="4">We are unable to find a Benefit Plan for the E-mail address and
                            Plan ID provided.</font><br/><br/>
                        <font face="verdana" size="4">Please contact your tax preparer for more details about this
                            Benefit Plan.</font><br/><br/>
                        <font face="verdana" size="4"><Link to="sign_in"><u><b>Sign in</b></u></Link> again</font>
                    </Jumbotron>
                    <Row>
                        <table className="logo-table">
                            <tbody>
                            <td className="left-brand-logo">
                                <img src={inituit_logo} alt="logo" width="120" height="40"/> <br/>
                                <Link to="/tnc" target="_blank"><font size="1.9" color="blue">Terms of
                                    Service</font></Link> |<a href="https://quickbooks.intuit.com/r/"
                                                              target="_blank"><font color="blue" size="1.75">
                                Privacy</font></a> <br/>
                                <font color="#00008b" size="1.75"> © 2019 Intuit Inc. All rights reserved.</font><br/>
                            </td>
                            <td className="right-brand-logo">
                                <TrustEBrandLogo />
                                <a href="https://sealinfo.verisign.com/splash?lang=en&dn=tax%2Design%2Eintuit%2Ecom&form%5Ffile=fdf%2Fsplash%2Efdf"
                                   target="_blank"> <img src={veri_sign} alt="logo" width="130" height="60"/></a>
                            </td>
                            </tbody>
                        </table>
                    </Row>
                </Grid>
            </div>);
    }
}

export default NotFound;